/*
 * Nordic Weaving - Mobil galleri-dots (IKEA-stil)
 * --------------------------------------------------
 * Erstatter thumbnail-striben med prikker/dots på mobil PDP.
 * Selv-injicerende: bygger dots i DOM'en, så main-product.liquid
 * ikke skal redigeres. Loades kun på produktsider via theme.liquid.
 *
 * Reversibel: fjern <script>-loadet i theme.liquid + denne fil.
 */
(function(){
  'use strict';

  function initGalleryDots(){
    var gallery = document.querySelector('.media-gallery');
    if (!gallery) return;
    if (gallery.dataset.nwDotsInit === '1') return;

    var main = gallery.querySelector('.main-image');
    if (!main) return;

    var carousel = main.querySelector('carousel-slider');
    if (!carousel) return;

    var slider = carousel.querySelector('.slider');
    if (!slider) return;

    var slides = [].slice.call(slider.querySelectorAll('.slider__item'));
    if (slides.length < 2) return;

    gallery.dataset.nwDotsInit = '1';

    // Byg dots-container
    var dotsEl = document.createElement('div');
    dotsEl.className = 'nw-gallery-dots';
    dotsEl.setAttribute('role', 'tablist');
    dotsEl.setAttribute('aria-label', 'Produktbilleder');

    var dots = [];
    slides.forEach(function(slide, i){
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'nw-gallery-dots__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('data-dot-index', i);
      dot.setAttribute('aria-label', 'Vis billede ' + (i + 1) + ' af ' + slides.length);
      if (i === 0) dot.setAttribute('aria-current', 'true');
      dot.addEventListener('click', function(){
        slider.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
      dotsEl.appendChild(dot);
      dots.push(dot);
    });

    // Indsæt dots lige efter hoved-billedblokken
    main.appendChild(dotsEl);

    function setActive(index){
      dots.forEach(function(dot, i){
        if (i === index){
          dot.classList.add('is-active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('is-active');
          dot.removeAttribute('aria-current');
        }
      });
    }

    // Lyt på Symmetry's eget carousel-event
    carousel.addEventListener('on:carousel-slider:select', function(e){
      if (e.detail && typeof e.detail.index === 'number'){
        setActive(e.detail.index);
      }
    });

    // Fallback: scroll-baseret detektion
    var scrollTimer;
    slider.addEventListener('scroll', function(){
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function(){
        var slideWidth = slides[0].clientWidth || 1;
        var idx = Math.round(Math.abs(slider.scrollLeft) / slideWidth);
        if (idx >= 0 && idx < dots.length) setActive(idx);
      }, 80);
    }, { passive: true });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initGalleryDots);
  } else {
    initGalleryDots();
  }
  // Kør igen efter kort tid hvis galleriet loades lazy
  setTimeout(initGalleryDots, 600);
  setTimeout(initGalleryDots, 1500);
})();
